/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./index.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useCallback } from 'react';
var styles = null;
export var StopPropagation = function StopPropagation(_ref) {
  var children = _ref.children;
  var onClick = useCallback(function (e) {
    // Prevent click event inside modal from bubble up
    e.stopPropagation();
  }, []);
  return /*#__PURE__*/React.createElement("span", {
    onClick: onClick,
    className: ax(["_c71lidpf _p12fidpf _kqswstnw"])
  }, children);
};